import React, {useState, useEffect} from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import GreenSubmitButton from '../buttons/greenSubmitButton';
import AppColors from '../assets/colors';
import { inject, observer } from "mobx-react";
import { useNavigate } from 'react-router-dom';

// Translations
import _useTranslate from '../hooks/_useTranslate';

const style = {
  position: 'absolute',
  width: {
    xs: '100%',
    sm: '80%', 
    md: 400,  
  },
  height: 350,
  top: {xs: 60, sm: '50%'},
  left: {xs: 0, sm: '50%'},
  transform: {sm: 'translate(-50%, -50%)'}, 
  bgcolor: 'background.paper',
  border: '2px solid var(--border-color)',
  borderRadius: 4,
  boxShadow: 24,
  p: 2,
};

const OrderCompleteModal = ({visible, onClickFinish, feathersStore})=> {

  let checkout = _useTranslate(feathersStore.language, "checkout");
  let common = _useTranslate(feathersStore.language, "common");
  const navigate = useNavigate();

  /* The order that was just placed — recorded by feathersStore.createOrder and
     persisted, so this works for a guest as well as a logged-in customer.
     Navigating straight to the tracking page is safe: the cart/session cleanup
     already happened when the order completed, and leaving the checkout route
     unmounts this modal anyway. */
  const latest = feathersStore.latestOrder;
  const trackUrl = latest?.id
    ? `/order/${latest.id}${latest.token ? `?t=${encodeURIComponent(latest.token)}` : ''}`
    : null;

  return (
    <section>
      <Modal 
        open={visible}        
        aria-labelledby="login-modal"
        aria-describedby="login-or-register"
      >
        <Box sx={style}>
          <div className="body-container">            
              <h2>{checkout.orderCompleteTitle}</h2>
              <p style={{color: AppColors.secondary, marginBottom: 30}}>{checkout.orderCompleteLine1}<br/>
              {checkout.orderCompleteLine2}</p>
              {trackUrl &&
                <GreenSubmitButton
                  title={common.trackOrder || 'Track my order'}
                  onClick={() => navigate(trackUrl)}
                  aria-labelledby='Track my order'
                  marginBottom={1}
                />
              }
              <GreenSubmitButton
                title={checkout.returnToShop}
                onClick={onClickFinish}
                variant={trackUrl ? "outlined" : "contained"}
                aria-labelledby='Back to shop'
              />
          </div>
        </Box>
      </Modal>
    </section>
  );
}

export default inject('feathersStore')(observer(OrderCompleteModal));